import { DEFAULT_LOCALE, LOCALE_CONFIG, type LocaleCode } from './locales'

export interface LocalePathResolution {
  locale: LocaleCode
  pathWithoutLocalePrefix: string
}

function normalizePath(pathname: string): string {
  if (!pathname) return '/'
  return pathname.startsWith('/') ? pathname : `/${pathname}`
}

export function resolveLocaleFromPath(pathname: string): LocalePathResolution {
  const normalizedPath = normalizePath(pathname)
  const lowercasePath = normalizedPath.toLowerCase()

  for (const [locale, config] of Object.entries(LOCALE_CONFIG) as [LocaleCode, (typeof LOCALE_CONFIG)[LocaleCode]][]) {
    if (!config.pathPrefix) continue

    if (lowercasePath === config.pathPrefix) {
      return { locale, pathWithoutLocalePrefix: '/' }
    }

    if (lowercasePath.startsWith(`${config.pathPrefix}/`)) {
      return {
        locale,
        pathWithoutLocalePrefix: normalizedPath.slice(config.pathPrefix.length) || '/',
      }
    }
  }

  return {
    locale: DEFAULT_LOCALE,
    pathWithoutLocalePrefix: normalizedPath,
  }
}

export function toLocalePath(pathname: string, locale: LocaleCode): string {
  const normalizedPath = normalizePath(pathname)
  const strippedPath = resolveLocaleFromPath(normalizedPath).pathWithoutLocalePrefix
  const prefix = LOCALE_CONFIG[locale].pathPrefix

  if (!prefix) {
    return strippedPath
  }

  return strippedPath === '/' ? prefix : `${prefix}${strippedPath}`
}

export function toCurrentLocalePath(currentPathname: string, targetPathname: string): string {
  const { locale } = resolveLocaleFromPath(currentPathname)
  return toLocalePath(targetPathname, locale)
}
